var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"box",staticStyle:{"position":"fixed","top":"0","left":"0","width":"100vw","height":"100vh","pointer-events":"none","z-index":"9999"}})}
var staticRenderFns = []

export { render, staticRenderFns }